export default __webpack_public_path__ + "static/media/fiverr.f104bc42.png";